import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  Validators,
} from "@angular/forms";
import moment from "moment";
import { ActivatedRoute } from "@angular/router";
import { ApiCallService } from "../../../api/service/api-call.service";
import * as Constants from "../../../constant/Constants";
import { ValidationService } from "src/app/services/validation.service";
import { IConfirmDialogData } from "src/app/components/dialog/dialog.data";
import { ConfirmComponent } from "src/app/components/dialog/confirm/confirm.component";
import { MatDialog } from "@angular/material/dialog";
import { Colors } from "src/app/assets/strings/colors";
import { Observable } from "rxjs";
import {map, startWith} from 'rxjs/operators';
import { environment } from "src/environments/environment";
import { TokenData, decodeLogbookJWTToken } from "src/app/util/HelperFunctions";

@Component({
  selector: "app-page-two",
  templateUrl: "./kyc.component.html",
  styleUrls: ["./kyc.component.css"],
})
export class KycComponent implements OnInit {
  VehicleBodyTypePlaceHolders: any = [
    "BUS",
    "CABROLET",
    "CAMPER VAN",
    "COUPE",
    "CROSSOVER",
    "HARDBODY PICKUP",
    "HATCHBACK",
    "HIGH SIDED LORRY",
    "LIFTBACK",
    "LIMOUSINE",
    "LORRY",
    "LORRY/TRUCK",
    "LOW SIDED LORRY",
    "MICRO",
    "MINI BUS",
    "MINI VAN",
    "MOTOR CYCLE",
    "PICKUP",
    "PICKUP DOUBLE CAB",
    "PRIME MOVER",
    "ROADSTER",
    "SALOON",
    "SEDAN",
    "SPORT CAR",
    "SUV",
    "S.WAGON",
    "TARGA",
    "TBA",
    "TIPPER",
    "TRACTOR",
    "TRAILER",
    "TRUCK",
    "UNIVERSAL",
    "VAN",
  ];

  GenderOptions: any = [
    "Male",
    "Female"
  ];

  genericDialogData: IConfirmDialogData = {
    title: '',
    content: '',
    cancelButtonText: '',
    confirmButtonText: ''
  };

  MarialStatusPlaceHolders: any = ["SINGLE", "MARRIED", "OTHER"];

  IdTypePlaceHolders: any = ["ID NUMBER", "PASSPORT NUMBER", "ALIEN CARD NUMBER"];
  selectedIdType: string = '';

  // Page Params
  journey: string = "new"; // new, existing ... etc.
  insurance: string = "private"; // private, motor, commercial ... etc.
  // token: string = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJwaG9uZU5vIjoiMjU0NzIyOTAzMzc3IiwiYWRkaXRpb25hbERhdGEiOnsiQm9keVR5cGUiOlsiUy5XQUdPTiJdLCJSZWdpc3RyYXRpb24iOlsiS0NKNDk4SCJdLCJDb2xvdXIiOlsiQlJPV04iXSwiQ2hhc3Npc0ZyYW1lIjpbIkFDQTMxLTUwNDQzMzQiXSwiRnVlbFR5cGUiOlsiUEVUUk9MIl0sIk1ha2VvZlZlaGljbGUiOlsiVE9ZT1RBIl0sIkRhdGVvZlJlZ2lzdHJhdGlvbiI6WyIyMDE2LTA5LTE3IDAwOjAwOjAwLjAiXSwiUmF0aW5nY2MiOlsiMjM2MCJdLCJNYW51ZmFjdHVyZVllYXIiOlsiMjAwOSJdLCJFbnRyeU5vIjpbIjIwMTZNU0E2MTU1MDQwIl0sIkVuZ2luZU5vIjpbIjJBWi1CNDExMDg1Il0sIlR5cGVvZlZlaGljbGUiOlsiTU9UT1IgVkVISUNMRSJdLCJOdW1iZXJvZlByZXZpb3VzT3duZXJzIjpbIjEiXSwiTnVtYmVyb2ZQYXNzZW5nZXJzIjpbIjUiXSwiVGFyZVdlaWdodEtncyI6WyIxNTIwLjAiXSwiVGF4Q2xhc3MiOlsiUFJJVkFURSJdLCJEdXR5IjpbIlBBSUQiXSwiUHJldmlvdXNSZWdpc3RyYXRpb24iOlsiSElNRUpJMzAwTUE3MjI1Il0sIk5vb2ZBeGxlcyI6WyIxIl0sIk1vZGVsIjpbIiJdLCJDb2RlIjpbIjIwMjAwIl0sIkJveE5vIjpbIjI2NCJdLCJQSU4iOlsiQTAwNTg3NzA0NEgiXSwiTm8iOlsiMjAyMjA2MTcwNDc0NTYxIl0sIk93bmVyc05hbWUiOlsiRU1NQU5VRUwgS0lQS09FQ0ggUk9QIl0sIlRvd24iOlsiS0VSSUNITyJdLCJPd25lcnNpZ25hdHVyZSI6WyIiXSwiUHJldmlvdXNSZWdDb3VudHJ5IjpbIiJdLCJHcm9zc1dlaWdodEtncyI6WyIiXSwiRm9yT2ZmaWNpYWxVc2VPbmx5QXV0aG9yaXNpbmdTaWduYXR1cmVhbmRPZmZpY2lhbFNlYWwiOlsiSCJdLCJMb2FkQ2FwYWNpdHlLZ3MiOlsiIl0sIlJDIjpbIigyMDIwLzEpIl19LCJpYXQiOjE2OTExMTM1ODIsImV4cCI6MTY5MTExNTM4Mn0.zZbNaad37RkC-Jk-2E7o8d3uCrHG1Py10ggRuys4jR4"; // to validate the public accesses.
  token: string = 'placeholder-value';
  // +++++++++++
  // data from token
  tokenData: TokenData | string = 'error';

  pageHeading: string =
    "Private vehicle motor insurance application (continued)";
  vehicleDetails: string = "Vehicle details";
  personalDetails: string = "Enter Personal Details";

  colourHint: string = "Start typing for colour suggestions";
  genderLabel: string = "Gender";
  dobLabel: string = "Date of birth";
  agentCodeLabel: string = "Please enter Agent Code (If Referred)";
  idTypeLabel: string = "Select identification Type";
  idNumLabel: string = "";
  kraNumLabel: string = "KRA Number";

  vehicleChassisNumberLabel: string = "Enter vehicle's chassis number";
  vehicleEngineNumberLabel: string = "Enter vehicle's engine number";
  vehicleColorLabel: string = "Enter vehicle's colour";
  vehicleCapacityLabel: string = "Enter vehicle's seating capacity";
  vehicleRatingLabel: string = "Enter vehicle's rating (cc)";
  vehicleBodyTypeLabel: string = "Select vehicle's body type";

  coverStartDateLabel: string = "Cover Start Date";
  coveStartDateDesc: string = "When you would like the cover to start";

  cancel: string = "Cancel";
  saveContinue: string = "Save and Continue";

  minDate: Date;
  maxDate: Date;

  minCoverDate: Date;
  maxCoverDate: Date;

  bodyDisabled: boolean = false;
  

  Colors: string[] = Colors;
  filteredColors: Observable<string[]>;

  motorFormContinued = this._formbuilder.group({
    gender: ["", Validators.required],
    email: ["", [Validators.required, Validators.email]],
    dob: [moment(null)],
    idType: [""],
    idNum: ["", Validators.required],
    kraNum: ["", [Validators.required, Validators.pattern(/^[AP]\d{9}[A-Z]$/)]],
    agentCode: [""],
    vehicleChassisNumber: ["", Validators.required],
    vehicleEngineNumber: ["", Validators.required],

    vehicleColor: ["", Validators.required],
    vehicleSeatingCapacity: ["", [Validators.required, Validators.min(1), Validators.max(8)]],

    vehicleRating: ["", [Validators.required, Validators.min(350)]],
    vehicleBodyType: ["", Validators.required],
    coverStartDate: [moment(null), Validators.required],
  });
  formErrors: { [key: string]: string } = {
    gender: "",
    email: "",
    dob: "",
    idType: "",
    idNum: "",
    kraNum: "",
    agentCode: "",
    vehicleChassisNumber: "",
    vehicleEngineNumber: "",
    vehicleColor: "",
    vehicleSeatingCapacity: "",
    vehicleRating: "",
    vehicleBodyType: "",
    coverStartDate: "",
  };
  validationMessages: { [key: string]: {[key: string]: string} } = {
    gender: { required: "This field is required" },
    email: { required: "This field is required", email: "Invalid email address" },
    dob: { required: "This field is required" },
    idType: { required: "This field is required" },
    idNum: { required: "This field is required", minlength: 'Invalid number', maxlength: 'Invalid number'},
    kraNum: { required: "This field is required", pattern: 'Invalid KRA PIN' },
    agentCode: { required: "This field is required" },
    vehicleChassisNumber: { required: "This field is required" },
    vehicleEngineNumber: { required: "This field is required" },
    vehicleColor: { required: "This field is required" },
    vehicleSeatingCapacity: {
      required: "This field is required",
      min: "Invalid value",
      max: "Maximum covered is 8 seats",
    },
    vehicleRating: { required: "This field is required", min: "Invalid value" },
    vehicleBodyType: { required: "This field is required" },
    coverStartDate: { required: "You have to select a start date for your cover" },
  };
  constructor(
    private route: ActivatedRoute,
    private apiCallService: ApiCallService,
    private _formbuilder: FormBuilder,
    private validationService: ValidationService,
    public dialog: MatDialog
  ) {
    const currentDate = new Date();
    const maxDob = new Date(currentDate.getTime());
    const minDob = new Date(currentDate.getTime());

    const maxCov = new Date(currentDate.getTime());
    const minCov = new Date(currentDate.getTime());

    minDob.setFullYear(currentDate.getFullYear() - 150);
    maxDob.setFullYear(currentDate.getFullYear() - 18);

    minCov.setFullYear(currentDate.getFullYear());
    maxCov.setFullYear(currentDate.getFullYear() + 1);

    this.minDate = minDob;
    this.maxDate = maxDob;

    this.minCoverDate = minCov;
    this.maxCoverDate = maxCov;

    this.filteredColors = this.motorFormContinued.controls["vehicleColor"].valueChanges.pipe(
      startWith(''),
      map(color => (color ? this._filterColors(color) : this.Colors.slice())),
    );
  }

  newUser: boolean = false;
  url: string = environment.baseUrl + Constants.kycPrivateURL;

  loading: boolean = false;

  minIDNUMLength: number = 8;
  maxIDNUMLength: number = 9;

  ngOnInit(): void {
    this.motorFormContinued.valueChanges.subscribe((form)=>{
      this.logErrors();

      if (form.vehicleSeatingCapacity) {
        this.motorFormContinued.patchValue({
          vehicleSeatingCapacity: form.vehicleSeatingCapacity.replace(/\D/g, '').replace(/^0+/, '')
        }, {emitEvent: false});
      }
      if (form.vehicleRating) {
        this.motorFormContinued.patchValue({
          vehicleRating: form.vehicleRating.replace(/\D/g, '').replace(/^0+/, '')
        }, {emitEvent: false});
      }
      
      if (form.kraNum) {
        this.motorFormContinued.patchValue({
          kraNum: form.kraNum.replace(/[a-z]/g, (match) => match.toUpperCase())
        }, {emitEvent: false});
      }

      if (form.agentCode) {
        this.motorFormContinued.patchValue({
          agentCode: form.agentCode.replace(/\D/g, '').replace(/^0+/, '')
        }, {emitEvent: false});
      }

      if (form.vehicleChassisNumber) {
        this.motorFormContinued.patchValue({
          vehicleChassisNumber: form.vehicleChassisNumber.replace(/[a-z]/g, (match) => match.toUpperCase())
        }, {emitEvent: false});
      }

      if (form.vehicleEngineNumber) {
        this.motorFormContinued.patchValue({
          vehicleEngineNumber: form.vehicleEngineNumber.replace(/[a-z]/g, (match) => match.toUpperCase())
        }, {emitEvent: false});
      }

      if (form.vehicleColor) {
        this.motorFormContinued.patchValue({
          vehicleColor: form.vehicleColor.replace(/[a-z]/g, (match) => match.toUpperCase())
        }, {emitEvent: false});
      }

      if (form.idType && form.idNum) {
        if (form.idType === 'ID NUMBER') {
          this.motorFormContinued.patchValue({
            idNum: form.idNum.replace(/\D/g, '').replace(/^0+/, '')
        }, {emitEvent: false});
        } else if (form.idType === 'PASSPORT NUMBER') {
          this.motorFormContinued.patchValue({
            idNum: form.idNum.replace(/^0+/, '')
        }, {emitEvent: false});
        }
      }
    })

    this.route.queryParams.subscribe((params) => {
      console.log('Params---> ',params); // log route params
      
      if (params["token"] !== 'undefined') {
        this.token = params["token"];
        // Autofill available data on form controls
        try {
          this.tokenData = decodeLogbookJWTToken(this.token);
      
          if ((this.tokenData && this.tokenData.additionalData)) {
            this.motorFormContinued.patchValue({
              vehicleBodyType: this.tokenData.additionalData.BodyType ? this.tokenData.additionalData.BodyType : '',
              vehicleEngineNumber: this.tokenData.additionalData.EngineNo ? this.tokenData.additionalData.EngineNo : '',
              vehicleRating: this.tokenData.additionalData.Ratingcc ? this.tokenData.additionalData.Ratingcc : '',
              vehicleColor: this.tokenData.additionalData.Colour ? this.tokenData.additionalData.Colour : '',
              vehicleChassisNumber: this.tokenData.additionalData.ChassisFrame ? this.tokenData.additionalData.ChassisFrame : '',
              dob: this.tokenData.additionalData.DOB ? moment(this.tokenData.additionalData.DOB) : moment(),
              idType: this.tokenData.additionalData.IDType || this.IdTypePlaceHolders[0],
              idNum: this.tokenData.additionalData.IDNumber ? this.tokenData.additionalData.IDNumber : '',
              kraNum: this.tokenData.additionalData.PIN ? this.tokenData.additionalData.PIN : '',
              email: this.tokenData.additionalData.email ? this.tokenData.additionalData.email : ''
            });

            this.updateID();
          }
        } catch (error) {console.log(':: Error ! ', error);}
      }

      // console.log('Token---> ',this.token);

      if (params["journey"] !== undefined) {
        this.journey = params["journey"];

        if (params["journey"] === "new") {
          this.newUser = true;
          
        }
      }
      if (params["insurance"] !== undefined) {
        this.insurance = params["insurance"];

        if (this.insurance === 'private' && params["token"] !== 'undefined') {
          this.token = params["token"];
        // Autofill available data on form controls
          try {
            this.tokenData = decodeLogbookJWTToken(this.token);
        
            if ((this.tokenData && this.tokenData.additionalData)) {
              this.motorFormContinued.patchValue({
                vehicleSeatingCapacity: this.tokenData.additionalData.NumberofPassengers[0] || '',
              });

              this.updateID();
            }
          } catch (error) {console.log(':: Error ! ', error);}
        }

        this.pageHeading =
          this.insurance[0].toUpperCase() +
          this.insurance.substring(1).toLowerCase() +
          " vehicle motor insurance application (continued)";

        if (this.insurance === "commercial") {
          this.url = environment.baseUrl + Constants.kycCommercialURL;
          this.motorFormContinued.get('vehicleSeatingCapacity')?.removeValidators(Validators.required)
        } else if (this.insurance === "special") {
          this.url = environment.baseUrl + Constants.kycSpecialURL;
          this.pageHeading =
            "Special type vehicle motor insurance application (continued)";
          this.motorFormContinued.get('vehicleSeatingCapacity')?.removeValidators(Validators.required)

        } else if (this.insurance === "motorcycle") {
          this.url = environment.baseUrl + Constants.kycMotorcycleURL;
          this.pageHeading = "Motorcycle insurance application (continued)";
          this.vehicleDetails = 'Motorcycle Details';
          this.vehicleChassisNumberLabel = 'Enter motorcycle\'s chassis number';
          this.vehicleEngineNumberLabel = 'Enter motorcycle\'s engine number';
          this.vehicleColorLabel = 'Enter motorcycle\'s colour';
          this.vehicleRatingLabel = 'Enter motorcycle\'s rating (cc)';

          this.motorFormContinued.get('vehicleSeatingCapacity')?.removeValidators(Validators.required);
          this.validationService.addOrRemoveValidatorSMinReq(true, this.motorFormContinued.get('vehicleRating')!, 50);

          this.motorFormContinued.get('vehicleBodyType')?.setValue('MOTOR CYCLE');
          this.bodyDisabled = true;
        }
      }

      this.validationService.addOrRemoveValidator(this.newUser,this.motorFormContinued.get('gender')!)
      this.validationService.addOrRemoveValidator(this.newUser,this.motorFormContinued.get('dob')!)
      this.validationService.addOrRemoveValidator(this.newUser,this.motorFormContinued.get('idType')!)
    });
  }
  
  _filterColors(value: string): string[] {
    const filterValue = value.toLowerCase();
    if (value.length > 1)
      return this.Colors.filter(color => color.toLowerCase().includes(filterValue)).sort(function(a, b){
        return a.length - b.length;
      });
    else 
      return this.Colors.filter(color => color.toLowerCase().includes(filterValue));
  }

  postDataToWhatsapp = async () => {
    this.loading = true;
    console.log(this.motorFormContinued.value);

    const req = {
      quoteNumber: "1",
      classCode: "970",
      classOfUse: this.insurance,
      typeOfCover: "COMP",
      dob: this.motorFormContinued.controls["dob"].value!.format("MM-DD-YYYY"),
      gender: this.motorFormContinued.controls["gender"].value,
      email: this.motorFormContinued.controls["email"].value,
      idType: this.motorFormContinued.controls["idType"].value,
      idNum: this.motorFormContinued.controls["idNum"].value,
      kraNum: this.motorFormContinued.controls["kraNum"].value,
      agentCode: this.motorFormContinued.controls["agentCode"].value,
      vehicleChassisNumber:
        this.motorFormContinued.controls["vehicleChassisNumber"].value,
      vehicleEngineNumber:
        this.motorFormContinued.controls["vehicleEngineNumber"].value,

      vehicleColor: this.motorFormContinued.controls["vehicleColor"].value,
      vehicleSeatingCapacity: // private insurance only
        this.motorFormContinued.controls["vehicleSeatingCapacity"].value,

      vehicleRating: this.motorFormContinued.controls["vehicleRating"].value,
      vehicleBodyType:
        this.motorFormContinued.controls["vehicleBodyType"].value,
      coverStartDate:
        this.motorFormContinued.controls["coverStartDate"].value!.format(
          "MM-DD-YYYY"
        ),
      token: this.token,
      filled: true,
    };

    try {
      // Update form data (POST)
      const response = await this.apiCallService.postRequest(`${this.url}?token=${this.token}`, req);
      
      console.log(":: Response data ::  ", response);

      if (response.error === false) {
        // Navigate back to Whatsapp chat
        window.location.href = environment.whatsappRedirectURL;
      } else {
        this.loading = false;

        this.initDialogData(
          'Submission Failed',
          'An error occurred while saving the form details',
          'cancel',
          'TRY AGAIN'
        );

        this.showGenericPopup(this.postDataToWhatsapp);
      }
    } catch (error) {
      console.error(error)
      this.loading = false;

      this.initDialogData(
        'Submission Failed',
        'An unexpected error occurred',
        'cancel',
        'TRY AGAIN'
      );
      this.showGenericPopup(this.postDataToWhatsapp);
    }

    
  }

  submitForm(): void {
    this.initDialogData(
      'Confirm submission',
      'Please proceed only if you have verified that the form details are correct',
      'Back',
      'Proceed'
    );

    this.showGenericPopup(this.postDataToWhatsapp);
  }

  showGenericPopup(runFunction: ()=> void) {
    const dialogRef = this.dialog.open(ConfirmComponent, {
      disableClose: true,
      data: this.genericDialogData,
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        runFunction();
      }
    });
  };

  initDialogData(title: string, content: string, cancelButtonText: string, confirmButtonText: string) {
    this.genericDialogData.title = title;
    this.genericDialogData.content = content;
    this.genericDialogData.cancelButtonText = cancelButtonText;
    this.genericDialogData.confirmButtonText = confirmButtonText;
  };

  logErrors() {
    this.validationService.logValidationErrors(
      this.motorFormContinued,
      this.formErrors,
      this.validationMessages
    );
  }

  // Switches IDNum label text + input based on ID Type control
  updateID() {
    if (this.motorFormContinued.controls['idType'].value !== null) {
      let s: string = 'Enter ';
      this.selectedIdType = this.motorFormContinued.controls['idType'].value;
      this.idNumLabel = s.concat(this.selectedIdType);
      
      // unused for now
      if (this.selectedIdType === 'ID NUMBER') {
        this.minIDNUMLength = 6;
        this.maxIDNUMLength = 9;
      } else if (this.selectedIdType === 'PASSPORT NUMBER') {
        this.minIDNUMLength = 7;
        this.maxIDNUMLength = 9;
      } else if (this.selectedIdType === 'ALIEN CARD NUMBER') {
        this.maxIDNUMLength = 11;
      }
      
      this.validationService.addOrRemoveIDumValidator(this.newUser,this.motorFormContinued.get('idNum')!, this.minIDNUMLength, this.maxIDNUMLength)
    }
  };

  displayValue(value: any) {
    return value;
  }

  confirmCancel() {
    this.initDialogData(
      'Warning',
      'Are you sure you want to cancel the application?',
      'back',
      'Cancel application'
    );

    this.showGenericPopup(this.cancelApplication);
  }

  cancelApplication = async () =>  {
    // Update session that form application was cancelled
    this.loading = true;

    const req = {
      // User cancelled
      token: this.token,
      filled: false,
    };

    try {
      const response = await this.apiCallService.postRequest(`${this.url}?token=${this.token}`, req);
      if (response.error === false) {
        // Navigate back to Whatsapp chat
        window.location.href = environment.whatsappRedirectURL;
        
      } else {
        console.error("::: Cancel Post failed :::", response.message);
        this.loading = false;

        this.initDialogData(
          'Failed',
          'An error occurred while attempting to cancel your application',
          'Cancel',
          'TRY AGAIN'
        );

        this.showGenericPopup(this.cancelApplication);
      }
    } catch (error) {
      console.error(error);
      this.loading = false;

      // Navigate back to Whatsapp chat
      window.location.href = environment.whatsappRedirectURL;
    }
  }
}
